import { HStack, Text, VStack } from 'ui_2';
import { BiChevronRight } from 'react-icons/bi';
import { useDappState } from '@src/hooks/useDappState';
import eth_3d from '@assets/eth_3d.png';

export const GoToGiveaways = () => {
  const { isPuzzleWalletWebview } = useDappState();

  return (
    <button
      onClick={() => {
        const url = isPuzzleWalletWebview
          ? 'https://app.puzzle.online/store'
          : 'https://store.puzzle.online';
        window.open(url, '_blank');
      }}
      className='w-full'
    >
      <HStack className='w-full items-center gap-2 rounded-[10px] border border-gray-100 px-4 py-3'>
        <img src={eth_3d} width='36px' height={'37px'} />
        <VStack>
          <Text font='bold-sm'>Win ETH and gift cards!</Text>
          <Text font='sm'>New giveaways live daily!</Text>
        </VStack>
        <HStack className='flex-grow' />
        <BiChevronRight className='justify-end text-gray-400' size={24} />
      </HStack>
    </button>
  );
};
